import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const ContactUs = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState({ name: '', email: '', phone: '', message: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email || !phone || !message) {
      setError({
        name: !name ? 'Name is required' : '',
        email: !email ? 'Email is required' : '',
        phone: !phone ? 'Phone is required' : '',
        message: !message ? 'Message is required' : ''
      });
      return;
    }

    const formData = new FormData();
    formData.append('name', name);
    formData.append('email', email);
    formData.append('phone', phone);
    formData.append('message', message);

    try {
      const response = await fetch('https://formspree.io/f/mkgkwagv', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      });

      const result = await response.json();
      if (response.ok) {
        setSubmitted(true);
        setName('');
        setEmail('');
        setPhone('');
        setMessage('');
        setError({ name: '', email: '', phone: '', message: '' });
      } else {
        console.error(result);
        alert('Oops! Something went wrong. Please try again later.');
      }
    } catch (err) {
      console.error('Submission error:', err);
      alert('Network error. Please check your connection.');
    }
  };

  return (
    <section className="contact-section">
      <motion.div
        className="contact-header"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <h2>Contact Us</h2>
        <p>We would love to hear from you, whether you are visiting, seeking prayer, or want to get involved.</p>
      </motion.div>

      <div className="contact-grid">
        <motion.div className="contact-card" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} viewport={{ once: true }}>
          <FaPhoneAlt className="contact-icon" />
          <h3>Call Us</h3>
          <p>+61 0449 939 449</p>
        </motion.div>

        <motion.div className="contact-card" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }} viewport={{ once: true }}>
          <FaEnvelope className="contact-icon" />
          <h3>Email</h3>
          <p>info@rccgdavidscourt.org</p>
        </motion.div>

        <motion.div className="contact-card" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.6 }} viewport={{ once: true }}>
          <FaMapMarkerAlt className="contact-icon" />
          <h3>Visit Us</h3>
          <p>97 Hensman Street, South Perth, WA</p>
        </motion.div>
      </div>

      {submitted ? (
        <motion.div className="thank-you" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }}>
          <h3>Thank you for reaching out!</h3>
          <p>We have received your message and will get back to you shortly.</p>
        </motion.div>
      ) : (
        <motion.form className="contact-form" onSubmit={handleSubmit} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} viewport={{ once: true }}>
          <h3>Send Us a Message</h3>

          <input type="text" placeholder="Your Name" value={name} onChange={(e) => setName(e.target.value)} />
          {error.name && <p className="error">{error.name}</p>}

          <input type="email" placeholder="Your Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          {error.email && <p className="error">{error.email}</p>}

          <input type="tel" placeholder="Your Phone" value={phone} onChange={(e) => setPhone(e.target.value)} />
          {error.phone && <p className="error">{error.phone}</p>}

          <textarea placeholder="Your Message" rows="5" value={message} onChange={(e) => setMessage(e.target.value)} />
          {error.message && <p className="error">{error.message}</p>}

          <button type="submit">Submit</button>
          <p className="form-footer-text">We respect your privacy. Your information is never shared and only used to respond to your inquiry.</p>
        </motion.form>
      )}
    </section>
  );
};

export default ContactUs;
